import { MAX_LEGEND_ITEMS_SELECTED } from "../constants";
import type { DataItem, MetaData } from "../types";

export const initMetaData = ({
    data,
    availableColors,
    othersColor,
}: {
    data: Omit<DataItem, "color" | "visible">[];
    availableColors: string[];
    othersColor: string;
}): MetaData => {
    const result: MetaData = {
        availableColors: [...availableColors],
        colorsMap: {},
        visibleIds: new Set(),
    };

    data.forEach((item, index) => {
        if (index < MAX_LEGEND_ITEMS_SELECTED) {
            const color = result.availableColors.shift() ?? othersColor;
            result.visibleIds.add(item.id);
            result.colorsMap[item.id] = color;
        }
    });

    return result;
};
